import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';

const client = getTsCustomerPortalClient();

/**
 * Opts the patient out of their current pharmacy referral, providing a reason.
 *
 * @returns optOut, isPending
 */
export const useOptOutPatientPharmacyReferral = () => {
  const { mutateAsync, isPending } = client.optOutPatientPharmacyReferral.useMutation();

  const optOut = (reason: string) =>
    mutateAsync({
      body: { data: { reason } },
    });

  return {
    optOut,
    isPending,
  };
};
